export default "__VITE_ASSET__4c8862fd__"